<style lang="scss" src="./style.scss" scoped></style>
<script src="./BaseSelector.js"></script>
<i18n src="./BaseSelector.yaml" lang="yaml"></i18n>

<template>
  <BaseLabel
      :vuelidate="vuelidate"
      :label="label"
      :customErrors="customErrors"
  >
    <select
        @input="updateValue"
        v-bind="$attrs"
        :class="errorClass"
    >
      <option value="" disabled selected>Select your option</option>
      <option value="less_than_5kg">{{ t('less_than_5kg') }}</option>
      <option value="5_to_10kg">{{ t('5_to_10kg') }}</option>
      <option value="10_to_20kg">{{ t('10_to_20kg') }}</option>
      <option value="over_20kg">{{ t('over_20kg') }}</option>
    </select>
  </BaseLabel>
</template>
